var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdver2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5005,
    cy: 11.5,
    r: 11.5,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42671 13.803H6.92471L6.51071 15H5.18771L7.44671 8.709H8.91371L11.1727 15H9.84071L9.42671 13.803ZM9.08471 12.795L8.17571 10.167L7.26671 12.795H9.08471ZM14.4131 8.718C15.0731 8.718 15.6521 8.847 16.1501 9.105C16.6541 9.363 17.0411 9.732 17.3111 10.212C17.5871 10.686 17.7251 11.238 17.7251 11.868C17.7251 12.498 17.5871 13.05 17.3111 13.524C17.0411 13.992 16.6541 14.355 16.1501 14.613C15.6521 14.871 15.0731 15 14.4131 15H12.2171V8.718H14.4131ZM14.3681 13.929C15.0281 13.929 15.5381 13.749 15.8981 13.389C16.2581 13.029 16.4381 12.522 16.4381 11.868C16.4381 11.214 16.2581 10.704 15.8981 10.338C15.5381 9.966 15.0281 9.78 14.3681 9.78H13.4771V13.929H14.3681Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5005 3.5L3.50049 19.5",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdver2);
export default __webpack_public_path__ + "static/media/Adver2.728adc8a16b91f8aeba814122f6b165f.svg";
export { ForwardRef as ReactComponent };